import { Outlet, ScrollRestoration } from "react-router-dom";

import { Header, NavigationBar } from "@/features/navigation";
import { cn } from "@/shared/lib/css";
import { useIsMobile } from "@/shared/lib/use-mobile";
import { usePageLayout } from "@/shared/lib/use-page-layout";
import { useTrafficSource } from "@/shared/lib/use-traffic-source";
import Footer from "@/shared/ui/footer";
import { Particles } from "@/shared/ui/kit/particles";
import { Toaster } from "@/shared/ui/kit/sonner";
import { UpdateBanner } from "@/shared/ui/kit/update-banner";

import { GlobalDialogs } from "./global-dialogs";
import { useAppTitle } from "./use-app-title";
import { useSyncUnread } from "./use-sync-unread";

export function App() {
  useTrafficSource();
  useSyncUnread();
  useAppTitle();
  const { showFooter, showNavBar } = usePageLayout();
  const isMobile = useIsMobile();

  const isHomePage = location.pathname === "/";
  const isTicketsPage = location.pathname.startsWith("/tickets");
  const authRoutes = location.pathname.startsWith("/auth");
  const infoRoutes = location.pathname.startsWith("/faq");
  const legalRoutes = location.pathname.startsWith("/legal");

  console.log(location.pathname);
  const showParticles =
    !isHomePage && !isTicketsPage && !authRoutes && !infoRoutes && !legalRoutes;

  return (
    <>
      <ScrollRestoration getKey={(location) => location.pathname} />
      <Toaster position="bottom-right" />
      <GlobalDialogs />
      <UpdateBanner />
      <div className="flex min-h-viewport-full flex-col bg-background">
        <Header />
        {showParticles && (
          <Particles
            quantity={isMobile ? 25 : 50}
            color="#7f67ff"
            className="fixed inset-0 z-0 pointer-events-none"
          />
        )}
        <main
          className={cn(
            "relative z-10 flex-1 h-full w-full",
            isMobile && showNavBar && !showFooter && "pb-20",
          )}
        >
          <Outlet />
        </main>
        {showFooter && (
          <Footer className={cn(isMobile && showNavBar && "pb-20")} />
        )}
        {isMobile && showNavBar && <NavigationBar />}
      </div>
    </>
  );
}
